export default __webpack_public_path__ + "static/product2-f998e720ab6ce2d3e2a137f488a82865.png";